export enum FilterOperation {
  Intersection = 'intersection',
  Union = 'union',
}
